import { HandoutShell, HandoutBrand, FeatureItem, HandoutFooter } from "./HandoutShell";
import {
  House, TreeStructure, TrendDown, Scales, Coins, Wallet,
  ChartPieSlice, FolderLock, Certificate, Receipt, PlugsConnected, Robot,
} from "@phosphor-icons/react";

const FEATURES = [
  { icon: House, title: "Live compliance dashboard", desc: "A real-time compliance score and every KPI at a glance." },
  { icon: TreeStructure, title: "Grant Guardian", desc: "Pace spend against budget; export audit-hashed grant reports.", color: "#00A86B" },
  { icon: TrendDown, title: "Cash Runway", desc: "See exactly how many months of runway you have left." },
  { icon: Scales, title: "Multi-jurisdiction compliance", desc: "IE + UK deadlines — CRO, CT, VAT, RBO — tracked & dated.", color: "#00A86B" },
  { icon: Coins, title: "Tax Reliefs", desc: "EII · SURE · R&D credit calculators built in." },
  { icon: Wallet, title: "Payroll & payslips", desc: "Generate compliant payslips in a couple of clicks.", color: "#00A86B" },
  { icon: ChartPieSlice, title: "Cap Table & scenarios", desc: "Interactive ownership modelling for funding rounds." },
  { icon: FolderLock, title: "Data Room + DD checklist", desc: "Investor-ready document room with due-diligence tracking.", color: "#00A86B" },
  { icon: Certificate, title: "Compliance Certificate & Trust Center", desc: "Tamper-evident public proof of compliance you can share." },
  { icon: Receipt, title: "AI receipt OCR + bank import", desc: "Scan receipts and auto-categorise bank lines with AI.", color: "#00A86B" },
  { icon: PlugsConnected, title: "ERP exports & integrations", desc: "One-click CSV to Xero, Sage, NetSuite, Workday & more." },
  { icon: Robot, title: "Compliance AI advisor", desc: "Ask anything — get Revenue.ie-aware answers instantly.", color: "#00A86B" },
];

export default function HandoutWeb() {
  return (
    <HandoutShell testid="handout-web">
      <HandoutBrand tag="Web Platform" />

      <div className="mb-6">
        <div className="eyebrow mb-2">The Compliance Finance OS · for the browser</div>
        <h1 className="font-display text-3xl leading-tight">
          Your entire compliance &amp; finance cockpit — <span style={{ color: "#FFB020" }}>in one place.</span>
        </h1>
        <p className="text-white/65 text-sm mt-3 max-w-2xl leading-relaxed">
          PerCen360 replaces a mess of spreadsheets, reminders and last-minute panics with a single,
          audit-ready workspace for Irish &amp; UK founders and their accountants.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-x-8 gap-y-4">
        {FEATURES.map((f) => (
          <FeatureItem key={f.title} {...f} />
        ))}
      </div>

      <div className="grid grid-cols-3 gap-4 mt-7">
        {[
          { k: "IE + UK", v: "multi-jurisdiction" },
          { k: "GDPR", v: "consent on record" },
          { k: "Audit-hashed", v: "tamper-evident reports" },
        ].map((s) => (
          <div key={s.k} className="glass rounded-xl px-4 py-3">
            <div className="mono text-lg" style={{ color: "#FFB020" }}>{s.k}</div>
            <div className="text-[11px] text-white/55 mt-0.5">{s.v}</div>
          </div>
        ))}
      </div>

      <HandoutFooter />
    </HandoutShell>
  );
}
